import { useState, useCallback } from "react"

/**
 * Custom hook for managing equipment page modals state
 * @returns {Object} Modal states and handlers
 */
export const useEquipmentModals = () => {
  const [categoryModalOpen, setCategoryModalOpen] = useState(false)
  const [addEquipmentModalVisible, setAddEquipmentModalVisible] = useState(false)
  const [deactivateDeleteModalState, setDeactivateDeleteModalState] = useState({
    visible: false,
    action: null, // 'deactivate' or 'delete'
    equipment: null,
    mode: null, // Mode determined from API response
    details: null // Detailed data from API
  })

  const openCategoryModal = useCallback(() => setCategoryModalOpen(true), [])
  const closeCategoryModal = useCallback(() => setCategoryModalOpen(false), [])

  const openAddEquipmentModal = useCallback(() => setAddEquipmentModalVisible(true), [])
  const closeAddEquipmentModal = useCallback(() => setAddEquipmentModalVisible(false), [])

  const openDeactivateModal = useCallback((equipment) => {
    setDeactivateDeleteModalState({
      visible: true,
      action: 'deactivate',
      equipment
    })
  }, [])

  const openDeleteModal = useCallback((equipment) => {
    setDeactivateDeleteModalState({
      visible: true,
      action: 'delete',
      equipment
    })
  }, [])

  const closeDeactivateDeleteModal = useCallback(() => {
    setDeactivateDeleteModalState({
      visible: false,
      action: null,
      equipment: null,
      mode: null,
      details: null
    })
  }, [])

  const setDeactivateDeleteDetails = useCallback((details) => {
    setDeactivateDeleteModalState((prev) => ({
      ...prev,
      details,
      mode: details?.mode || null
    }))
  }, [])

  return {
    // Category Modal
    categoryModalOpen,
    openCategoryModal,
    closeCategoryModal,
    // Add Equipment Modal
    addEquipmentModalVisible,
    openAddEquipmentModal,
    closeAddEquipmentModal,
    // Deactivate/Delete Modal
    deactivateDeleteModalState,
    openDeactivateModal,
    openDeleteModal,
    closeDeactivateDeleteModal,
    setDeactivateDeleteDetails
  }
}
